import './ProductDetailPage.scss';

export default function ProductDetailPage() {
  return (
    <div>
      <h1>Product Detail Page</h1>
    </div>
  );
}
